import React from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import MarqueeServices from '@/components/MarqueeServices';
import Services from '@/components/Services';
import WhyDifferent from '@/components/WhyDifferent';
import CallToAction from '@/components/CallToAction';
import Footer from '@/components/Footer';
import AnimatedBackground from '@/components/AnimatedBackground';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black relative">
      <AnimatedBackground />
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <MarqueeServices />
        <Services />
        <WhyDifferent />
        <CallToAction />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
